import React from 'react';
import { Link } from 'react-router-dom';
import { createStyles, withStyles } from '@material-ui/core/styles';
import LogoImg from 'assets/logo-welearn-bg-white.svg';

const styles = (theme) =>
  createStyles({
    container: {
      paddingLeft: 16,
      textAlign: 'center',
      marginBottom: 30,
    },
  });

function LogoComponent({ classes }) {
  return (
    <div className={classes.container}>
      <Link to="/">
        <img src={LogoImg} style={{ width: 130, height: 'auto' }} />
      </Link>
    </div>
  );
}

export default withStyles(styles)(LogoComponent);
